import { render } from "./ServiceProviderOnboardingPage.vue?vue&type=template&id=5e246b41"
import script from "./ServiceProviderOnboardingPage.vue?vue&type=script&lang=js"
export * from "./ServiceProviderOnboardingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__